import { useEnrollPatientMutation } from '@common/cache';
import { formatApiError } from '@common/errors/error-formatting';
import { useState } from 'react';
import { toast } from 'react-toastify';

export const useAddServicesAndPrograms = (patient_id: string) => {
  const { mutateAsync, isPending, variables } =
    useEnrollPatientMutation(patient_id);

  const [isAddProgramOpen, setIsAddProgramOpen] = useState(false);

  const handleCloseAddProgramModal = () => {
    setIsAddProgramOpen(false);
  };

  const handleOpenAddProgramModal = () => {
    setIsAddProgramOpen(true);
  };

  const handleEnrollProgram = async (program_id: string) => {
    try {
      await mutateAsync({
        patient_id,
        program_id,
      });

      toast.success('Patient enrolled successfully');
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };

  return {
    isAddProgramOpen,
    isPending,
    handleCloseAddProgramModal,
    handleOpenAddProgramModal,
    handleEnrollProgram,
    variables,
  };
};
